import { render, staticRenderFns } from "./TheBusinessNav.vue?vue&type=template&id=10d66468"
import script from "./TheBusinessNav.vue?vue&type=script&lang=js"
export * from "./TheBusinessNav.vue?vue&type=script&lang=js"
import style0 from "./TheBusinessNav.vue?vue&type=style&index=0&id=10d66468&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports